export default __webpack_public_path__ + "ab8113ee51f69e34d5ac70ccf6f82561.png";